module.exports = __webpack_public_path__ + "static/media/power-play-games-logo.fb1d2562.png";